import arrow from './arrow';
import circle from './circle';
import curve from './curve';
import rect from './rect';
import triangle from './triangle';
import parallelogram from './parallelogram';
import fibonacciExtension from './fibonacciExtension';
import fibonacciSpeedResistanceFan from './fibonacciSpeedResistanceFan';
import fibonacciCircle from './fibonacciCircle';
import fibonacciSegment from './fibonacciSegment';
import fibonacciSpiral from './fibonacciSpiral';
import gannBox from './gannBox';
import threeWaves from './threeWaves';
import fiveWaves from './fiveWaves';
import eightWaves from './eightWaves';
import anyWaves from './anyWaves';
import abcd from './abcd';
import xabcd from './xabcd';
import textBox from './textBox';
import alertPriceLine from './alertPriceLine';

export const customOverlays = [
  arrow, circle, curve, rect, triangle, parallelogram,
  fibonacciExtension, fibonacciSpeedResistanceFan, fibonacciCircle, fibonacciSegment, fibonacciSpiral,
  gannBox,
  threeWaves, fiveWaves, eightWaves, anyWaves,
  abcd, xabcd,
  textBox,
  alertPriceLine,
];
